<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 19">
    <path
      d="M15.5 11.441V8.43541C15.5 8.25593 15.5 8.16619 15.4727 8.08696C15.4485 8.0169 15.4091 7.95309 15.3572 7.90014C15.2986 7.84027 15.2183 7.80013 15.0578 7.71987L10.5 5.44098M2.5 6.44098V13.2476C2.5 13.6195 2.5 13.8055 2.55802 13.9683C2.60931 14.1122 2.6929 14.2425 2.80238 14.3491C2.92622 14.4697 3.09527 14.5471 3.43335 14.7021L9.83335 17.6354C10.0786 17.7478 10.2012 17.804 10.3289 17.8262C10.4421 17.8459 10.5579 17.8459 10.6711 17.8262C10.7988 17.804 10.9214 17.7478 11.1666 17.6354L17.5666 14.7021C17.9047 14.5471 18.0738 14.4697 18.1976 14.3491C18.3071 14.2425 18.3907 14.1122 18.442 13.9683C18.5 13.8055 18.5 13.6195 18.5 13.2476V6.44098M0.5 5.44098L10.1422 0.619868C10.2734 0.554277 10.339 0.521482 10.4078 0.508574C10.4687 0.497142 10.5313 0.497142 10.5922 0.508574C10.661 0.521482 10.7266 0.554277 10.8578 0.619868L20.5 5.44098L10.8578 10.2621C10.7266 10.3277 10.661 10.3605 10.5922 10.3734C10.5313 10.3848 10.4687 10.3848 10.4078 10.3734C10.339 10.3605 10.2734 10.3277 10.1422 10.2621L0.5 5.44098Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
